import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import {
    selectActiveEntitiesArray,
    selectEntitiesArray
} from 'services/entities/selectors';
// @ts-ignore
import { selectCurrentEntityId } from 'services/currentEntityId/selectors';

// Utils
// @ts-ignore
import orderBy from 'utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);
const selectEntityTypeId = (state: any, props: any): any => props.entityTypeId;
const selectShowDeletedEntities = (state: any, props: any): any =>
    props.showDeletedEntities;

const selectEntities = createDeepEqualSelector(
    selectEntitiesArray,
    selectActiveEntitiesArray,
    selectShowDeletedEntities,
    (entitiesArray, activeEntitiesArray, showDeletedEntities) => {
        if (showDeletedEntities) {
            return entitiesArray;
        }

        return activeEntitiesArray;
    }
);

const selectFilteredData = createDeepEqualSelector(
    [selectEntities, selectCurrentEntityId, selectEntityTypeId],
    (activeEntitiesArray, currentEntityIdState, entityTypeIdState) =>
        activeEntitiesArray.filter((value: any) => {
            const { entityTypeId, path } = value;
            if (entityTypeIdState && entityTypeIdState !== entityTypeId) {
                return false;
            }
            if (currentEntityIdState && !path) {
                return false;
            }
            if (
                currentEntityIdState &&
                !`${path}/`.includes(`/${currentEntityIdState}`)
            ) {
                return false;
            }
            return true;
        })
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    (filteredDataState) => orderBy(filteredDataState, 'name')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    (orderedDataState) =>
        orderedDataState.map(({ id, name }: any) => ({
            key: id,
            text: name,
            value: `${id}`
        }))
);

export { selectOptions, selectFilteredData };
